import { render, staticRenderFns } from "./workerDetails.vue?vue&type=template&id=261ed240&scoped=true&"
import script from "./workerDetails.vue?vue&type=script&lang=js&"
export * from "./workerDetails.vue?vue&type=script&lang=js&"
import style0 from "./workerDetails.vue?vue&type=style&index=0&id=261ed240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ed240",
  null
  
)

export default component.exports